export default "__VITE_ASSET__ChzOZqSz__"